import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { useParams, useHistory } from 'react-router-dom'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import ProposalMoreRequest from '../../../widgets/moreRequest/ProposalMoreRequest'
import MoreRequestStaffEditForm from '../../../widgets/moreRequestStaffEdit/MoreRequestStaffEdit'
import {
  getSummaryReviseRequest,
  updateSummaryReviseRequest,
} from '../../../redux/actions/summaryReviseRequest'
import { startLoading, doneLoading } from '../../../utils/loading'
import SummaryReviseRequestViewWidget from './SummaryReviseRequestViewWidget'
import { Panel, RadioGroup, Radio, Message } from 'rsuite'
import { Controller } from 'react-hook-form'
import CKEditor from 'ckeditor4-react'
import ConfirmWidget from '../../../widgets/confirm/ConfirmWidget'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import pathname from '../../../constants/pathname'
import { Link } from 'react-router-dom'

export default function SummaryReviseRequest() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState()
  const [isShowConfimModal, setIsShowConfimModal] = useState(false)
  const [isShowSuccess, setIsShowSuccess] = useState(false)
  const [error, setError] = useState()
  const [optionValue, setOptionValue] = useState('2')
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  let history = useHistory()

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getSummaryReviseRequest(projectVersionId)
      setSchema(response.model)

      //setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleCallSaveService = async () => {
    setIsShowConfimModal(false)
    setIsLoading(true)
    startLoading()
    try {
      const response = await updateSummaryReviseRequest(projectId, optionValue)
      if (response.success) {
        if (optionValue == '2') {
          handleGetSchema(projectId)
        } else {
          doneLoading()
          setIsLoading(false)

          setIsShowSuccess(true)
          // return history.push(`${pathname.proposal.overview.overviewCoworker}/${projectId}`)
          //return history.push(`${pathname.proposal.overview.overviewCoworker}`)
        }
      }
      setIsShowConfimModal(false)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setIsError(e.response.data.errors?.message)
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
    setIsShowConfimModal(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={8}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

        <Panel shaded header={schema?.header} bordered collapsible defaultExpanded>
          <SummaryReviseRequestViewWidget schema={schema?.forms?.projectFeedback?.revises} />
          {schema?.forms?.projectFeedback?.optionValue == '1' && (
            <div>
              <div style={{ marginTop: 10, marginBottom: 10 }}>
                <Message
                  showIcon
                  type="warning"
                  description={'การปรับปรุงแก้ไขครั้งนี้ "นักวิชาการสำนัก" เป็นผู้ปรับแก้ให้'}
                />
              </div>
              <RadioGroup
                onChange={(value) => {
                  // props.onChange(value)
                  setOptionValue(value)
                }}
                value={optionValue}
                defaultValue={'2'}
                //checked={checkApprove}
              >
                <Radio value={'2'}>
                  {'ขอปรับปรุงแก้ไขข้อมูลเพิ่มเติมจากสิ่งที่นักวิชาการสำนักปรับปรุงแก้ไข'}
                </Radio>
                <Radio value={'3'}>{'ยืนยันข้อมูลตามที่นักวิชาการสำนักปรับปรุงแก้ไข'}</Radio>
              </RadioGroup>
              {/* )
              }}
            /> */}

              <hr />

              {isError && (
                <div style={{ marginTop: 10, marginBottom: 10 }}>
                  <Message showIcon type="error" description={isError} />
                </div>
              )}

              <SaveButton disabled={isLoading} onClick={() => setIsShowConfimModal(true)}>
                {'บันทึก'}
              </SaveButton>
            </div>
          )}
        </Panel>
        <br />

        <ConfirmWidget
          title={`ยืนยันการบันทึก`}
          show={isShowConfimModal}
          detail={`กรุณายืนยันบันทึก`}
          onCancle={() => setIsShowConfimModal(false)}
          onConfirm={() => handleCallSaveService()}
        />

        <ConfirmWidget
          size="sm"
          title={`แจ้งเตือน`}
          show={isShowSuccess}
          detail={
            <>
              ยืนยันเรียบร้อย กรุณาไปดำเนินการ{' '}
              <Link
                to={{
                  pathname: `${pathname.proposal.overview.submitEdit}`,
                }}
                // onClick={() => {
                //   // sessionStorage.setItem('projectId', projectId)
                //   // sessionStorage.setItem('param', `?${schema.requestId}`)
                //   history.push(`${pathname.proposal.overview.submitEdit}`)
                // }}
              >
                <u>ส่งแก้ไขข้อเสนอโครงการ</u>
              </Link>
            </>
          }
          hideConfirm
          onCancle={() => setIsShowSuccess(false)}
          cancleBtn="ปิด"
          // onConfirm={() => handleCallSaveService()}
        />
      </SidebarProposal>
    </>
  )
}

const mockSchema = {
  header: 'สรุปความเห็นให้ปรับปรุงแก้ไข',
  subHeader: 'ข้อเสนอโครงการ ไม้ร่ม เปลี่ยนที่ว่างให้เป็นผืนป่า สน.6 ก005',
  projectVersionId: 'EBF36AB2-C8FF-44A7-A222-9FF3BB15C636',
  forms: {
    projectFeedback: {
      header: 'สรุปความเห็นให้ปรับปรุงแก้ไข',
      projectReviewId: '',
      revises: [
        {
          id: '1-1001',
          label: 'ข้อมูลทั่วไปของโครงการ',
          subItems: [
            {
              id: '1-1002',
              projectFeedbackId: null,
              label: 'ลักษณะ ประเภทข้อเสนอ และระยะเวลาดำเนินโครงการ',
              value: null,
              placeholder: null,
              enableInput: true,
              disabled: false,
              selected: false,
              subItems: [],
              validators: null,
            },
            {
              id: '1-1003',
              projectFeedbackId: null,
              label: 'ความสอดคล้องกับทิศทางเป้าหมายยุทธศาสตร์ และวัตถุประสงค์',
              value: null,
              placeholder: null,
              enableInput: true,
              disabled: false,
              selected: false,
              subItems: [
                {
                  id: '1-1004',
                  projectFeedbackId: null,
                  label: 'ความสอดคล้องกับทิศทาง เป้าหมาย และยุทธศาสตร์ระยะ 10 ปี (2555-2564)',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  disabled: false,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
                {
                  id: '1-1005',
                  projectFeedbackId: null,
                  label: 'ความสอดคล้องกับวัตถุประสงค์ตาม พ.ร.บ. ของ สสส.',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  disabled: false,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
              ],
              validators: null,
            },
            {
              id: '1-1006',
              projectFeedbackId: null,
              label: 'กลุ่มเป้าหมายดำเนินการ ประเด็น และพื้นที่ดำเนินการ',
              value: null,
              placeholder: null,
              enableInput: true,
              disabled: false,
              selected: false,
              subItems: [
                {
                  id: '1-1007',
                  projectFeedbackId: null,
                  label: 'กลุ่มเป้าหมายดำเนินการ',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  disabled: false,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
                {
                  id: '1-1008',
                  projectFeedbackId: null,
                  label: 'ประเด็น',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  disabled: false,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
                {
                  id: '1-1009',
                  projectFeedbackId: null,
                  label: 'พื้นที่ดำเนินการ (setting)',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  disabled: false,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
                {
                  id: '1-1010',
                  projectFeedbackId: null,
                  label: 'พื้นที่ดำเนินการ (ตามเขตการปกครอง)',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  disabled: false,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
              ],
              validators: null,
            },
          ],
        },
        {
          id: '1-1011',
          label: 'ข้อเสนอโครงการ',
          subItems: [
            {
              id: '1-1012',
              projectFeedbackId: null,
              label: 'ชื่อโครงการ',
              value:
                '*ไม่ระบุ* te       st สรุปความเห็นปรับปรุงlkasdlsamdksamdl;msal;dsaml;dmal;ml;samcl;saml;cmaslcmsal;mc asl;mcl;samc;lsamcsalc sac sal;cl;sa cl;sa c;ls c;sacka ck;sa c;ka sck as;cka sk;c askc ak;cask cka ck;s cas \n1.ให้แก้ไข ชื่อ       โครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา',
              placeholder: null,
              enableInput: true,
              disabled: false,
              selected: true,
              subItems: [],
              validators: null,
            },
            {
              id: '1-1013',
              projectFeedbackId: null,
              label: 'ความเป็นมา หลักการและเหตุผล',
              value:
                '*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา',
              placeholder: null,
              enableInput: true,
              disabled: false,
              selected: true,
              subItems: [],
              validators: null,
            },
            {
              id: '1-1014',
              projectFeedbackId: null,
              label: 'เป้าประสงค์ วัตถุประสงค์',
              value: null,
              placeholder: null,
              enableInput: false,
              disabled: false,
              selected: false,
              subItems: [
                {
                  id: '1-1015',
                  projectFeedbackId: null,
                  label: 'เป้าประสงค์',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  disabled: false,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
                {
                  id: '1-1016',
                  projectFeedbackId: null,
                  label: 'วัตถุประสงค์',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  disabled: false,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
                {
                  id: '1-1017',
                  projectFeedbackId: null,
                  label: 'ผลลัพธ์, ตัวชี้วัด (outcome / Impact) : เชิงคุณภาพ',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  disabled: false,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
                {
                  id: '1-10171',
                  projectFeedbackId: null,
                  label: 'กรอบแนวคิดและยุทธศาสตร์',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  disabled: false,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
                {
                  id: '1-10172',
                  projectFeedbackId: null,
                  label: 'แผนดำเนินงาน/(ระเบียบวิธีการวิจัย)',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  disabled: false,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
              ],
              validators: null,
            },
            {
              id: '1-1018',
              projectFeedbackId: null,
              label: 'กิจกรรม และงบประมาณ',
              value: null,
              placeholder: null,
              enableInput: false,
              disabled: false,
              selected: false,
              subItems: [
                {
                  id: '1-1019',
                  projectFeedbackId: null,
                  label: 'กิจกรรม',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  disabled: false,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
                {
                  id: '1-1020',
                  projectFeedbackId: null,
                  label: 'เงินสนับสนุนโครงการ',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  disabled: false,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
                {
                  id: '1-1023',
                  projectFeedbackId: null,
                  label: 'ค่าตอบแทนคู่สัญญา',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  disabled: false,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
                {
                  id: '1-1024',
                  projectFeedbackId: null,
                  label: 'งบประมาณสมทบจากแหล่งอื่น ๆ (อยู่นอกเหนืองบประมาณโครงการที่ขอรับกับ สสส)',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  disabled: false,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
              ],
              validators: null,
            },
            {
              id: '1-1025',
              projectFeedbackId: null,
              label: 'โครงสร้างการบริหารโครงการ',
              value: null,
              placeholder: null,
              enableInput: true,
              disabled: false,
              selected: false,
              subItems: [],
              validators: null,
            },
            {
              id: '1-1026',
              projectFeedbackId: null,
              label: 'คณะทำงาน',
              value: null,
              placeholder: null,
              enableInput: true,
              disabled: false,
              selected: false,
              subItems: [],
              validators: null,
            },
            {
              id: '1-1027',
              projectFeedbackId: null,
              label: 'การกำกับติดตาม และการประเมินติดตามภายใน',
              value: null,
              placeholder: null,
              enableInput: true,
              disabled: false,
              selected: false,
              subItems: [],
              validators: null,
            },
            {
              id: '1-1028',
              projectFeedbackId: null,
              label: 'ผลที่คาดว่าจะได้รับ',
              value: null,
              placeholder: null,
              enableInput: true,
              disabled: false,
              selected: false,
              subItems: [],
              validators: null,
            },
          ],
        },
        {
          id: '1-1029',
          label: 'ผู้รับทุน ผู้รับผิดชอบโครงการ',
          subItems: [
            {
              id: '1-1030',
              projectFeedbackId: null,
              label: 'ผู้รับทุน',
              value: null,
              placeholder: null,
              enableInput: true,
              disabled: false,
              selected: false,
              subItems: [],
              validators: null,
            },
            {
              id: '1-1031',
              projectFeedbackId: null,
              label: 'ผู้รับผิดชอบโครงการ',
              value: null,
              placeholder: null,
              enableInput: true,
              disabled: false,
              selected: false,
              subItems: [],
              validators: null,
            },
            {
              id: '1-1032',
              projectFeedbackId: null,
              label: 'คุณสมบัติพื้นฐานและลักษณะต้องห้ามผู้นำเสนอโครงการ',
              value: null,
              placeholder: null,
              enableInput: true,
              disabled: false,
              selected: false,
              subItems: [],
              validators: null,
            },
          ],
        },
        {
          id: '1-1040',
          label: 'ภาคผนวก',
          subItems: [
            {
              id: '1-1041',
              projectFeedbackId: null,
              label: 'แนบไฟล์ประกอบโครงการอื่นๆ ที่เกี่ยวข้อง',
              value: null,
              placeholder: null,
              enableInput: true,
              disabled: false,
              selected: false,
              subItems: [],
              validators: null,
            },
            {
              id: '1-1042',
              projectFeedbackId: null,
              label: 'สรุปความเห็นปรับปรุง',
              value:
                'test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา\n*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา*ไม่ระบุ* test สรุปความเห็นปรับปรุง\n1.ให้แก้ไข ชื่อโครงการ\n2.แก้ไขความเป็นมา',
              placeholder: null,
              enableInput: true,
              disabled: false,
              selected: true,
              subItems: [],
              validators: null,
            },
          ],
        },
      ],
    },
  },
}
